import { Injectable, Injector } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpContextToken } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import {tap} from "rxjs/operators"
import { HttpCacheService } from '../services/http-cache.service';
import { LoggerService } from '../services/logger.service';


export const CACHEABLE=new HttpContextToken(()=>false);
@Injectable()
export class CacheInterceptor implements HttpInterceptor {

  constructor(private cacheService:HttpCacheService, private injector: Injector) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if(request.method !== "GET"){
      this.cacheService.invalidateCache();
      this.debugLog("CacheInterceptor", "invalidating cache!");
      return next.handle(request);
    }
    if(!request.context.get(CACHEABLE)){

      return next.handle(request);

    }

    const cachedResponse=this.cacheService.get(request.url);

    if(cachedResponse){
      this.debugLog("CacheInterceptor", "got data from cache", request.url);
      return of(cachedResponse);
    }
     return next.handle(request)
    .pipe(
      tap(event=>{
        if(event instanceof HttpResponse)
        {

        this.cacheService.put(request.url, event);
        return;
      }
    }));
  }

  /**
   * LoggerService is resolved per call instead of injected into the constructor.
   *
   * Interceptors are instantiated lazily, on the application's first HTTP request. If that
   * request originates from a service constructor (analytics used to flush its queued events
   * that way), the interceptor is built while LoggerService is still mid-construction, and
   * `inject(LoggerService)` returns Angular's internal CIRCULAR sentinel — an empty object —
   * because the cyclic-dependency guard is `ngDevMode`-only and therefore absent in production
   * builds. The interceptor instance is memoised for the lifetime of the page, so a constructor
   * injection would poison every later request with "this.logger.debug is not a function",
   * failing each POST/PUT/DELETE before it ever leaves the browser.
   */
  private debugLog(context: string, message: string, ...args: any[]): void {
    try {
      const logger = this.injector.get(LoggerService, null);
      if (typeof logger?.debug === 'function') {
        logger.debug(context, message, ...args);
      }
    } catch {
      // Logging must never break an HTTP request.
    }
  }
}
